import 'slick-carousel';
import { getCart } from '../_partials/cart/header.part';

$(function() {
	let conflictItems = [];
	let properties = [];
	let groups = [];

	if ($('#conf').length) {
		let $loading = $('#conf-loading');
		let ID = $('#btn-configurator').data('id');

		$.ajax({
			url: '/api/product/' + ID + '/properties',
			method: 'GET',
			timeout: 0,
			headers: {
				'X-Token': window.cartToken // токен
			},
			success: function(response) {
				$loading.hide();
				// console.log(response.groups);
				response.groups.forEach(item => {
					let group = $('.configurator__tab-entry.tpl')
						.clone()
						.removeClass('tpl');
					let property = {};
					let propertyName = item.id;
					groups.push(propertyName);
					property[propertyName] = null;
					properties.push(property);
					item.properties.forEach(prop => {
						let label = $('.radio__custom.tpl')
							.clone()
							.removeClass('tpl');
						label
							.find('input')
							.attr('id', prop.id)
							.attr('name', 'properties[' + item.id + ']')
							.val(prop.id)
							.attr('data-group', item.id)
							.end()
							.find('.custom__title')
							.html(prop.title)
							.end()
							.appendTo(group);
						if (prop.conflicts.length) {
							label.find('input').attr('data-conflicts', prop.conflicts);
						}
					});
					group
						.attr('id', 'group-' + item.id)
						.attr('data-id', item.id)
						.appendTo('.configurator__content');
					// if (item.default) {
					// 	group.find('input#' + item.default).prop('checked', true);
					// }
					$('.configurator__tab-entry:first-child').addClass('vis');
					$(`<a class="tabs__lnk" href="#group-${item.id}" data-id="${item.id}">${item.title}</a>`).appendTo(
						'.configurator__tabs'
					);
				});
				$('.configurator__tabs .tabs__lnk:first-child').addClass('tabs__lnk_current');
			},
			error: function (response) {
				$loading.hide();
				$('#conf-container').hide();
				$('#conf-error').show();
			}
		});

		$('body').on('change', '.configurator__content input', function() {
			let id = $(this)
				.closest('.configurator__tab-entry')
				.attr('data-id');
			let propertyVal = $(this).attr('id');
			let propertyGroup = $(this).attr('data-group');

			properties.forEach((property, index) => {
				if (parseInt(Object.keys(property)) === parseInt(propertyGroup)) {
					property[id] = propertyVal;
				}
			});

			groups.forEach((group, index) => {
				if (
					index >
					$(this)
						.closest('.configurator__tab-entry')
						.index()
				) {
					$('.configurator__content .configurator__tab-entry:eq(' + index + ')')
						.find('input')
						.prop('checked', false);
					setTimeout(function() {
						$('.configurator__tabs .tabs__lnk_current')
							.nextAll()
							.removeClass('pointed');
					});
				}
			});

			$('.configurator__tabs .tabs__lnk[href="#group-' + id + '"]')
				.removeClass('tabs__lnk_current')
				.addClass('pointed')
				.next('.tabs__lnk')
				.addClass('tabs__lnk_current');

			if (
				$(this)
					.closest('.configurator__tab-entry')
					.is(':last-child')
			) {

				let ID = $('#btn-configurator').data('id');
				let data = {
					id: ID,
					properties: properties || null
				};
				let $loading = $('#btn-loading');

				$loading.show();

				$.ajax({
					url: '/api/product/create-pdf',
					method: 'POST',
					contentType: 'application/json',
					dataType: 'json',
					headers: {
						'X-Token': window.cartToken
					},
					data: JSON.stringify(data),
					success: function(response) {
						$('#btn-spec').attr('href', response.url)
						$('.card__btn-container').removeClass('disabled');
						$loading.hide();
					},
				});

				return false;
			} else {
				$(this)
					.closest('.configurator__tab-entry')
					.removeClass('vis')
					.next('.configurator__tab-entry')
					.addClass('vis');
			}

			noConflict($(this));
		});

		function noConflict(input) {
			if (typeof input.attr('data-conflicts') !== typeof undefined && input.attr('data-conflicts') !== false) {
				let conflictItemsCurrent = input.attr('data-conflicts').split(',');
				conflictItems = conflictItems.concat(conflictItemsCurrent);

				conflictItems.forEach(item => {
					if (input.prop('checked', true)) {
						$('#' + parseInt(item))
							.prop('checked', false)
							.closest('label')
							.addClass('disabled');
					} else {
						$('#' + parseInt(item))
							.closest('label')
							.removeClass('disabled');
					}
				});
			}
		}
	}

	$('.btn-cart').click(function(e) {
		e.preventDefault();

		let $this = $(this);
		let $loading = $this.find('.loading');
		let ID = $this.data('id');
		let data = {
			id: ID,
			properties: properties || null
		};

		if ($(this).is('.js-add-to-cart')) {
			$loading.show();

			$.ajax({
				url: '/api/cart',
				method: 'POST',
				timeout: 0,
				contentType: 'application/json',
				dataType: 'json',
				headers: {
					'X-Token': window.cartToken
				},
				data: JSON.stringify(data),
				success: function(response) {
					$loading.hide();
					getCart();
					$this
						.addClass('btn_lightblue btn-in-cart')
						.removeClass('btn_blue js-add-to-cart')
						.text('В корзине');
				},
				error: function(response) {
					console.error(response, 'e');
					$loading.hide();

					$('<p>Произошла ошибка. Попробуйте еще раз</p>').appendTo('.card__btn');
				}
			});
		} else if ($(this).is('.btn-in-cart')) {
			window.location.href = '/cart';
		}
	});

	// function setConfigDefaults(defaults) {
	// 	defaults.forEach(item => {
	// 		$('#' + item).prop('checked', true);
	// 	});
	// }

	$('.photo__list').slick({
		slidesToShow: 1,
		asNavFor: '.photo__thumbs',
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					asNavFor: false,
					dots: true,
					fade: false
				}
			}
		]
	});

	$('.photo__thumbs').slick({
		vertical: true,
		slidesToShow: 4,
		asNavFor: '.photo__list',
		focusOnSelect: true,
		arrows: true,
		rows: 0,
		responsive: [
			{
				breakpoint: 767,
				settings: 'unslick'
			}
		]
	});

	$('.catalog-showcase .catalog__list').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		rows: 0,
		arrows: true,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				}
			}
		]
	});

	$('.js-btn-config').click(function(e) {
		e.preventDefault();

		$('html, body').animate(
			{
				scrollTop: $('.card__tabs').offset().top - 160
			},
			500
		);
	});

	$('body').on('click', '.configurator__tabs .tabs__lnk', function(e) {
		e.preventDefault();

		let tab = $(this).attr('href');

		$(this)
			.nextAll()
			.removeClass('tabs__lnk_current');
		$('.configurator__tab-entry').removeClass('vis');
		$(tab).addClass('vis');
	});

	$('.card__tabs .tabs__lnk').click(function(e) {
		e.preventDefault();

		let tab = $(this).attr('href');

		$('.card__tabs-container .card__tab').hide();
		$(tab).show();
		$('html, body').animate({ scrollTop: $('.card__tabs-container').offset().top - 110 });
	});

	$('body').on('click', '.docs__entry .entry__head', function() {
		$(this)
			.closest('.docs__entry')
			.toggleClass('vis');
	});

	$(window).scroll(function() {
		fixTabs();
	});
	fixTabs();

	let tabsOffset = $('.card__tabs').offset().top + 80;

	function fixTabs() {
		if ($(window).scrollTop() > tabsOffset) {
			$('.card__tabs').addClass('fixed');
		} else {
			$('.card__tabs').removeClass('fixed');
		}
	}
});
